var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collection-banner" }, [
    _c(
      "div",
      {
        staticClass: "collection-banner__main-container",
        style: _vm.backgroundImage
      },
      [
        _c(
          "div",
          {
            staticClass: "collection-banner__content",
            class: _vm.contentClasses
          },
          [
            _c("h3", { staticClass: "collection-banner__heading" }, [
              _vm._v(_vm._s(_vm.banner.heading))
            ]),
            _vm.banner.copy
              ? _c("p", { staticClass: "collection-banner__copy" }, [
                  _vm._v(_vm._s(_vm.banner.copy))
                ])
              : _vm._e(),
            _vm.$mq !== "mobile" && _vm.banner.ctaText && _vm.banner.ctaUrl
              ? _c(
                  "v-button",
                  {
                    class: _vm._f("ctaClass")(_vm.banner.ctaStyle),
                    attrs: { href: _vm.banner.ctaUrl, tag: "a" }
                  },
                  [_vm._v(_vm._s(_vm.banner.ctaText))]
                )
              : _vm._e(),
            _vm.$mq === "mobile" && _vm.banner.ctaText && _vm.banner.ctaUrl
              ? _c(
                  "v-link",
                  {
                    attrs: {
                      primary: "",
                      light: this.banner.overlayColor === "Dark",
                      "custom-classes": _vm._f("linkColorClass")(
                        _vm.banner.overlayColor
                      ),
                      href: _vm.banner.ctaUrl
                    }
                  },
                  [_vm._v(_vm._s(_vm.banner.ctaText))]
                )
              : _vm._e()
          ],
          1
        ),
        _vm.banner.overlayColor && _vm.banner.overlayOpacity
          ? _c("div", {
              staticClass: "collection-banner__overlay-container",
              class: _vm._f("overlayColorClass")(_vm.banner.overlayColor),
              style: _vm.overlayOpacity
            })
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }